import {
  updateCurrencyDisplays,
  setupUpdateCurrencyDisplays,
} from '../admin/update-currencies';
import $ from 'jquery';

export default function invoiceForm() {
  setupUpdateCurrencyDisplays();
  var invoiceItemTemplate = $('#invoice-item-template').html();

  $(document).on('click', '.remove_item', function (e) {
    e.preventDefault();

    $(this).parents('.invoice_item').remove();
  });
  $('.add_item').on('click', function (e) {
    e.preventDefault();

    $('#items').append(
      invoiceItemTemplate.replace(/{{INDEX}}/g, $('.invoice_item').length),
    );
    updateCurrencyDisplays();
  });
}
